<template>
  <div>
    <el-row class="header" type="flex" justify="center">
      <el-col :xs="22" :sm="20" :lg="18">
        <h1>
          <img :src="geImageUrl">
        </h1>
        <div class="download-field">
          <el-button :loading="loading" @click="dataDownload" type="success" plain>銘柄コードのリストをダウンロード</el-button>
        </div>
        <div class="description">
          <div class="title" @click="listShow()"><span class="symbol">{{ symbol }}</span>数値と計算式について</div>
          <transition name="trans_slide">
            <table v-if="list">
              <tr>
                <th>スコアの見方</th>
                <td>すべて偏差値で表示されています。「50」は全銘柄の平均。「50」を基準にして銘柄の良し悪しがわかります。</td>
              </tr>
              <tr>
                <th>ﾄﾚﾝﾄﾞ出現</th>
                <td>トレンドの発生しやすさを評価。集計期間に対してトレンドの期間が長いほど良いスコアになります。</td>
              </tr>
              <tr>
                <th>ﾄﾚﾝﾄﾞ継続</th>
                <td>トレンドの継続しやすさを評価。単発のトレンドが多くあるよりも、長期間のトレンドがあるほど良いスコアになります。</td>
              </tr>
              <tr>
                <th>ｶｳﾝﾃｨﾝｸﾞ</th>
                <td>トレンド期の値動きの安定性を評価。上昇トレンドの連続カウント４、下降の連続カウント－４が多いほど良いスコアになります。</td>
              </tr>
              <tr>
                <th>価格変動</th>
                <td>トレンド期のプラスの価格変動を評価。トレンド期のTRをもとに評価。トレンド期の「プラスの価格変動」が「マイナスの価格変動」より大きいほど良いスコアになる。</td>
              </tr>
              <tr>
                <th>窓</th>
                <td>トレンド期の窓を評価。トレンド期のマイナス方向の窓が発生すると減点。</td>
              </tr>
              <tr>
                <th>ヒゲ</th>
                <td>トレンド期のヒゲを評価。トレンド期のマイナス方向のヒゲが発生すると減点。</td>
              </tr>
              <tr>
                <th>売買代金</th>
                <td>一日に動く資金量。「株価 ✕ 20日平均した出来高」で算出しています。</td>
              </tr>
              <tr>
                <th>配当利回り</th>
                <td>配当利回りとは、「購入した株価に対し、1年間でどれだけの配当を受けることができるか」を示す数値です。「一株当たりの年間配当金 ／ 株価」で算出。</td>
              </tr>
            </table>
          </transition>
        </div>
      </el-col>
    </el-row>
    <el-row type="flex" justify="center">
      <el-col :xs="22" :sm="20" :lg="18">
        <el-card v-loading="loading">
          <el-row type="flex" justify="center" align="middle" style="margin-bottom: 1em;">
            <el-col :span="4" align="middle" style="color: #909399;font-weight: 500;">高さ変更</el-col>
            <el-col :span="20"><el-slider v-model="tableHeight" :step="500" :max="5000" show-stops></el-slider></el-col>
          </el-row>
          <div class="mb-4">
            <el-input v-model="searchQuery" placeholder="検索" />
          </div>
          <el-table ref="tableRef" row-key="date" :data="filteredView" style="width: 100%" :height="tableHeight">
            <el-table-column
              sortable
              prop="brand_name"
              label="会社名"
              width="150"
              fixed="left"
              :filters="createFiltersData('brand_name')"
              :filter-method="filterHandler"
            />
            <el-table-column
              sortable
              prop="code"
              label="銘柄コード"
              width="140"
              :filters="createFiltersData('code')"
              :filter-method="filterHandler" />
            <el-table-column
              sortable
              prop="industry_type"
              label="業種"
              width="120"
              :filters="createFiltersData('industry_type')"
              :filter-method="filterHandler" />
            <el-table-column
              sortable
              prop="nikkei225"
              label="日経225"
              width="120"
              :filters="createFiltersData('nikkei225')"
              :filter-method="filterHandler" />
            <el-table-column
              sortable
              prop="nikkei400"
              label="日経400"
              width="120"
              :filters="createFiltersData('nikkei400')"
              :filter-method="filterHandler" />
            <el-table-column
              sortable
              prop="market_size"
              label="売買代金"
              width="150"
              :formatter="formatterMoneyDelemiter" />
            <el-table-column
              sortable
              prop="dividend_yield"
              label="配当利回り (％)"
              width="145" />
            <el-table-column
              sortable
              prop="per"
              label="PER"
              width="100" />
            <el-table-column
              sortable
              prop="pbr"
              label="PBR"
              width="100" />
            <el-table-column
              sortable
              prop="roe"
              label="ROE (％)"
              width="110" />
            <el-table-column
              sortable
              prop="trend_appear"
              label="ﾄﾚﾝﾄﾞ出現"
              width="120" />
            <el-table-column
              sortable
              prop="trend_continue"
              label="ﾄﾚﾝﾄﾞ継続"
              width="120" />
            <el-table-column
              sortable
              prop="counting"
              label="ｶｳﾝﾃｨﾝｸﾞ"
              width="110" />
            <el-table-column
              sortable
              prop="price_fluctuation"
              label="価格変動"
              width="110" />
            <el-table-column
              sortable
              prop="window"
              label="窓"
              width="100" />
            <el-table-column
              sortable
              prop="mustache"
              label="ヒゲ"
              width="100" />
            <el-table-column
              style="padding: 0px !important;"
              fixed="right"
              width="80">
              <template #default="scope">
                <el-button @click="details(scope)" size="small" type="primary" plain round>詳細</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
      </el-col>
    </el-row>
    <div class="daijyunkan">
      <el-dialog
        v-model="dialogVisible"
      >
        <div>
          <el-row justify="center">
            <el-col>
              <div class="contents">
                <div class="brand">
                  <span class="brand-code">{{dialogData.code}}</span><span class="brand-type">{{dialogData.industry_type}}</span>
                </div>
                <h2>{{dialogData.brand_name}}</h2>
                <div class="chart">
                  <RadarChart :chartData="raderData" :options="chartOptions" />
                </div>
                <p>{{dialogData.brand_description}}</p>
                <table class="nikkei">
                  <tr>
                    <th>日経225</th>
                    <td>{{dialogData.nikkei225}}</td>
                  </tr>
                  <tr>
                    <th>日経400</th>
                    <td>{{dialogData.nikkei400}}</td>
                  </tr>
                </table>
                <table class="numdata">
                  <tr>
                    <th>売買代金</th>
                    <td>{{filterMoneyDelemiter(dialogData.market_size)}}</td>
                  </tr>
                  <tr>
                    <th>配当利回り</th>
                    <td>{{dialogData.dividend_yield}}％</td>
                  </tr>
                  <tr>
                    <th>PER</th>
                    <td>{{dialogData.per}}</td>
                  </tr>
                  <tr>
                    <th>PBR</th>
                    <td>{{dialogData.pbr}}</td>
                  </tr>
                  <tr>
                    <th>ROE</th>
                    <td>{{dialogData.roe}}％</td>
                  </tr>
                </table>
              </div>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import { useRoute } from 'vue-router'
import { Chart, registerables } from 'chart.js'
import { RadarChart } from 'vue-chart-3'
import { axios } from '@/plugins/axios'
Chart.register(...registerables)

export default defineComponent({
  components: {
    RadarChart,
  },
  setup() {
    const route = useRoute()
    const dialogVisible = ref(false)
    const list = ref(false)
    const symbol = ref('▼')
    const loading = ref(false)
    const dialogData = ref()
    const brandInfo = ref()
    const tableHeight = ref(500)
    const searchQuery = ref('')
    const geImageUrl = computed(() => route.params.key == '1' ? require('@/assets/images/tools/daijyunkan/daijyunkan50_logo.png') : require('@/assets/images/tools/daijyunkan/daijyunkan100_logo.jpg'))
    const filteredView = computed(() => {
      if (!Array.isArray(brandInfo.value)) return []
      return brandInfo.value.filter(l => {
        return searchQuery.value.toLowerCase()
          .split(/\s+/)
          .map(
            q => l.code.toString().toLowerCase().indexOf(q) > -1
            || l.industry_type.toString().toLowerCase().indexOf(q) > -1
            || l.brand_name.toString().toLowerCase().indexOf(q) > -1
          )
          .every(result => result === true)
      })
    })

    const raderData = ref({
      labels: ['ﾄﾚﾝﾄﾞ出現', 'ﾄﾚﾝﾄﾞ継続', 'ｶｳﾝﾃｨﾝｸﾞ', '価格変動', '窓', 'ヒゲ'],
      datasets: [
        {
          label: 'レーダーチャート',
          borderColor: 'rgba(243, 176, 61)',
          backgroundColor: 'rgba(247, 231, 160, 0.6)',
          pointBorderColor: 'rgba(243, 176, 61)',
          data: [0, 0, 0, 0, 0, 0],
        },
      ]
    })
    const chartOptions = ref({
      plugins: {
        legend: {
          display: false,
        }
      },
      scale: {
        ticks: {
          min: 0,
          max: 80,
          beginAtZero: true,
          stepSize: 50,
          fontSize: 14
        },
        pointLabels: {
          fontSize: 14
        }
      },
      layout: {
        padding: {
          left: 5,
          right: 0,
          top: 0,
          bottom: 0
        }
      }
    })

    const details = (val) => {
      let chartData = JSON.parse(JSON.stringify(raderData.value))
      chartData.datasets[0].data = [val.row.trend_appear, val.row.trend_continue, val.row.counting, val.row.price_fluctuation, val.row.window, val.row.mustache]
      raderData.value = chartData
      dialogData.value = val.row
      dialogVisible.value = true
    }

    const filterHandler = (
      value,
      row,
      column
    ) => {
      const property = column['property']
      return row[property] === value
    }

    const fetchBrandInfo = async () => {
      loading.value = true
      await axios
        .get(`/screener-tool/fetch-daijunkan/${route.params.key}`)
        .then(async res => {
          brandInfo.value = res.data
          for (let index = 0; index < brandInfo.value.length; index++) {
            brandInfo.value[index].dividend_yield = parseFloat(brandInfo.value[index].dividend_yield)
            brandInfo.value[index].per = parseFloat(brandInfo.value[index].per)
            brandInfo.value[index].pbr = parseFloat(brandInfo.value[index].pbr)
            brandInfo.value[index].roe = parseFloat(brandInfo.value[index].roe)
            brandInfo.value[index].nikkei225 = brandInfo.value[index].nikkei225 === 1 ? '◯' : '×'
            brandInfo.value[index].nikkei400 = brandInfo.value[index].nikkei400 === 1 ? '◯' : '×'
          }
        })
      loading.value = false
    }

    const createFiltersData = (targetkey) => {
      const dropDuplicates = (targetObj, targetkey) => {
        if (Array.isArray(targetObj)) {
          return targetObj.filter (
            (obj1, i, self) => (
              self.findIndex((obj2) => obj2[targetkey] === obj1[targetkey]) === i
            )
          )
        }
        return []
      }
      let filtersData = []
      const targetObj = brandInfo.value
      dropDuplicates(targetObj, targetkey)
        .forEach((value, index) => {
          filtersData.push({text: value[targetkey], value: value[targetkey]})
        })
      return filtersData
    }

    const listShow = () => {
      list.value = !list.value
      if (list.value) {
        symbol.value = '▲'
      }
      else {
        symbol.value = '▼'
      }
    }

    const dataDownload = () => {
      let txtData = ''
      for (let index = 0; index < brandInfo.value.length; index++) {
        txtData += (index == brandInfo.value.length - 1)
          ? 'TSE:' + brandInfo.value[index].code
          : 'TSE:' + brandInfo.value[index].code + '\r\n'
      }
      // ファイルタイプ、保存するテキストを指定してblobを作成
      const blob = new Blob([ txtData ], {
        'type': 'text/plain'
      })
      // ダウンロード
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      const file_name = route.params.key == '1' ? 'コロナ銘柄50選.txt' : '大循環銘柄100選.txt'
      link.download = file_name
      link.click()
      // 空にする
      txtData = null
    }

    const formatterMoneyDelemiter = (row, column) => {
      const property = column['property']
      if (row[property] == null) return 'No Data'
      return row[property].toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    }

    const filterMoneyDelemiter = (value) => {
      if (value == null) return 'No Data'
      return value.toString().replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    }

    onMounted(() => {
      fetchBrandInfo()
    })

    return {
      loading,
      list,
      listShow,
      symbol,
      dialogVisible,
      raderData,
      chartOptions,
      details,
      filterHandler,
      brandInfo,
      createFiltersData,
      dialogData,
      dataDownload,
      geImageUrl,
      filteredView,
      searchQuery,
      tableHeight,
      formatterMoneyDelemiter,
      filterMoneyDelemiter
    }
  },
})
</script>

<style scoped>
.header {
  /* logo.jpgの背景色に合わせている */
  background-color: #f5f8fb;
}
.header p {
  color: #777;
}
.header img {
  width: 100%;
}
.download-field {
  margin: 20px 0;
}
.download-field .el-button {
  padding: 8px 12px;
}
</style>

<style scoped>
.description {
  margin: 30px 0;
}
.description .title {
  cursor: pointer;
  background-color: #ccc;
  padding: 10px;
  font-size: 1.3em;
}
.description .title .symbol {
  margin: 0 10px;
  color: #fff;
}
.description table {
  border-collapse: collapse;
  font-size: 1.2em;
}
.description table tr {
  border: solid 1px #ccc;
}
.description table tr th {
  padding: 10px;
  background-color: #ddd;
  border-right: solid 1px #ccc;
  font-weight: initial;
  min-width: 110px;
  width: 30%;
  text-align: center;
  font-size: 1em;
}
.description table tr td {
  padding: 10px;
  font-size: 0.9em;
  background-color: white;
}
.description .trans_slide-enter-active, .description .trans_slide-leave-active {
  transition: opacity 0.4s;
}
.description .trans_slide-enter, .description .trans_slide-leave-to {
  opacity: 0;
}
</style>

<style scoped>
.contents {
  font-size: 0.9em;
}
@media screen and (min-width: 768px) {
  .contents {
    font-size: 1.1em;
  }
}
.contents .brand {
  margin: 40px 0 10px 0;
}
.contents .brand .brand-code {
  background-color: #c7e4d1;
  padding: 4px 20px;
  margin-right: 2px;
  border-radius: 3px 0 0 3px;
}
.contents .brand .brand-type {
  background-color: #c7e4d1;
  padding: 4px 20px;
  border-radius: 0 3px 3px 0;
}
.contents h2 {
  font-size: 2em;
}
.contents .chart {
  width: 100%;
  margin: 0 auto;
}
@media screen and (min-width: 576px) {
  .contents .chart {
    width: 80%;
  }
}
.contents p {
  font-size: 1.2em;
}
.contents .nikkei {
  display: flex;
  border-collapse: collapse;
  margin: 20px 0;
}
.contents .nikkei tr {
  display: flex;
  width: 100%;
  border: solid 1px #ddd;
  align-items: center;
  justify-content: center;
}
.contents .nikkei tr th {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #e8e8e8;
  font-weight: initial;
  width: 100%;
  padding: 5px;
}
.contents .nikkei tr td {
  text-align: center;
  width: 100%;
  padding: 5px;
}
.contents .nikkei tr:nth-child(1) {
  margin-right: 10px;
}
.contents .numdata {
  border-collapse: collapse;
  width: 100%;
  margin: 20px 0;
}
.contents .numdata tr {
  border: solid 1px #bbb;
}
.contents .numdata tr th {
  background-color: #ddd;
  text-align: center;
  border-right: solid 1px #bbb;
  padding: 10px;
}
.contents .numdata tr td {
  background-color: #f5f8fb;
  text-align: right;
  padding: 10px;
}
</style>

<style>
.daijyunkan .el-dialog {
  margin: 20px auto !important;
  width: 90% !important;
  min-width: 280px;
  max-width: 600px;
  height: 90% !important;
  overflow: scroll;
}
.daijyunkan .el-dialog .el-dialog__header {
  padding: 0px !important;
}
.daijyunkan .el-dialog .el-dialog__header .el-dialog__headerbtn {
  position: static !important;
  float: right;
  margin: 15px 20px 0 0px;
}
.daijyunkan .el-dialog .el-dialog__body {
  padding: 5px 10px 5px 10px !important;
}
</style>

<style>
.el-table-filter .el-table-filter__bottom button:nth-child(1) {
  font-size: 0;
}
.el-table-filter .el-table-filter__bottom button:nth-child(1):before {
  font-size: 13px;
  content: "OK";
}
.el-table-filter .el-table-filter__bottom button:nth-child(2) {
  font-size: 0;
}
.el-table-filter .el-table-filter__bottom button:nth-child(2):before {
  font-size: 13px;
  content: "クリア";
}
</style>